import React from 'react';
import PropTypes from 'prop-types';
import { SVGIcon } from '@pearsontechnology/aero-components';
import { featureKeys } from 'services/FeatureFlagService';
import { PageNavLink } from 'components/PageStyles';
import { gtmTrackAuthoringDashboardUserInteraction } from 'utils/gtm/handler';
import { GTM_EVENT_CATEGORY, GTM_EVENT_ACTION } from 'utils/gtm/constants';
import {
  Nav,
  NavIcon,
  IconLeft,
} from './styles';
import enhanceWithFeatureFlagSubscription from 'hocs/enhanceWithFeatureFlagSubscription';

const NavItem = ({ icon, text, active, to, trackDashboardTocClick = false, getFeatureFlagValue }) => {
  const isRedesignedWorkspaceNew = getFeatureFlagValue(featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22);
  const handleNavItemClick = () => {
    if (!trackDashboardTocClick) {
      return;
    }    
    // Event ID 4 — Navigation Table Of Contents
    gtmTrackAuthoringDashboardUserInteraction({
      eventCategory: GTM_EVENT_CATEGORY.DASHBOARD,
      eventAction: GTM_EVENT_ACTION.CLICK_BRONTE_TABLE_OF_CONTENTS_OBJECT,
      eventLabel: text,
    });
  };
  const NavElement = (
    <Nav newUX={isRedesignedWorkspaceNew} active={active}>
      {
        icon && <IconLeft newUX={isRedesignedWorkspaceNew} active={active}>
          {isRedesignedWorkspaceNew ? <NavIcon
            icon={icon}
            viewBox="0 0 24 24"
          /> : <SVGIcon
            icon={icon}
            viewBox="0 0 24 24"
          />}
        </IconLeft>
      }
      { text }
    </Nav>
  );

  return to ? (<PageNavLink to={to} onClick={handleNavItemClick}> { NavElement } </PageNavLink>) : NavElement;
};

NavItem.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  to: PropTypes.string,
  active: PropTypes.bool,
  trackDashboardTocClick: PropTypes.bool,
};

const flagNames = [featureKeys.BRNT_18710_WORKSPACE_REDESIGN_22];
export default enhanceWithFeatureFlagSubscription(NavItem, flagNames);
